import React from 'react';

export const Slide1 = () => (
    <svg viewBox='0 0 301 369' fill='none'>
        <rect x='94.5' width='112' height='64.679' rx='4' fill='#fff' />
        <g xmlns='http://www.w3.org/2000/svg' clipPath='url(#a)'>
            <mask
                id='b'
                width='33'
                height='32'
                x='110'
                y='16'
                maskUnits='userSpaceOnUse'
                style={{maskType: 'luminance'}}
            >
                <path
                    fill='#fff'
                    d='M141.773 29.09h-14.909v6.183h8.581c-.8 3.927-4.145 6.181-8.581 6.181A9.436 9.436 0 0 1 117.409 32a9.436 9.436 0 0 1 9.455-9.454c2.254 0 4.291.8 5.891 2.108L137.409 20c-2.836-2.473-6.473-4-10.545-4-8.873 0-16 7.127-16 16 0 8.873 7.127 16 16 16 8 0 15.272-5.818 15.272-16 0-.945-.145-1.964-.363-2.91Z'
                />
            </mask>
            <g mask='url(#b)'>
                <path fill='#FBBC05' d='M109.409 41.455v-18.91L121.773 32l-12.364 9.455Z' />
            </g>
            <mask
                id='c'
                width='33'
                height='32'
                x='110'
                y='16'
                maskUnits='userSpaceOnUse'
                style={{maskType: 'luminance'}}
            >
                <path
                    fill='#fff'
                    d='M141.773 29.09h-14.909v6.183h8.581c-.8 3.927-4.145 6.181-8.581 6.181A9.436 9.436 0 0 1 117.409 32a9.436 9.436 0 0 1 9.455-9.454c2.254 0 4.291.8 5.891 2.108L137.409 20c-2.836-2.473-6.473-4-10.545-4-8.873 0-16 7.127-16 16 0 8.873 7.127 16 16 16 8 0 15.272-5.818 15.272-16 0-.945-.145-1.964-.363-2.91Z'
                />
            </mask>
            <g mask='url(#c)'>
                <path
                    fill='#EA4335'
                    d='M109.409 22.545 121.773 32l5.091-4.436 17.454-2.837V14.545h-34.909v8Z'
                />
            </g>
            <mask
                id='d'
                width='33'
                height='32'
                x='110'
                y='16'
                maskUnits='userSpaceOnUse'
                style={{maskType: 'luminance'}}
            >
                <path
                    fill='#fff'
                    d='M141.773 29.09h-14.909v6.183h8.581c-.8 3.927-4.145 6.181-8.581 6.181A9.436 9.436 0 0 1 117.409 32a9.436 9.436 0 0 1 9.455-9.454c2.254 0 4.291.8 5.891 2.108L137.409 20c-2.836-2.473-6.473-4-10.545-4-8.873 0-16 7.127-16 16 0 8.873 7.127 16 16 16 8 0 15.272-5.818 15.272-16 0-.945-.145-1.964-.363-2.91Z'
                />
            </mask>
            <g mask='url(#d)'>
                <path
                    fill='#34A853'
                    d='m109.409 41.455 21.818-16.728 5.746.727 7.345-10.909v34.91h-34.909v-8Z'
                />
            </g>
            <mask
                id='e'
                width='33'
                height='32'
                x='110'
                y='16'
                maskUnits='userSpaceOnUse'
                style={{maskType: 'luminance'}}
            >
                <path
                    fill='#fff'
                    d='M141.773 29.09h-14.909v6.183h8.581c-.8 3.927-4.145 6.181-8.581 6.181A9.436 9.436 0 0 1 117.409 32a9.436 9.436 0 0 1 9.455-9.454c2.254 0 4.291.8 5.891 2.108L137.409 20c-2.836-2.473-6.473-4-10.545-4-8.873 0-16 7.127-16 16 0 8.873 7.127 16 16 16 8 0 15.272-5.818 15.272-16 0-.945-.145-1.964-.363-2.91Z'
                />
            </mask>
            <g mask='url(#e)'>
                <path
                    fill='#4285F4'
                    d='M144.318 49.455 121.773 32l-2.909-2.182 25.454-7.273v26.91Z'
                />
            </g>
        </g>
        <path fill='url(#a)' d='M110.5 16h32v32.679h-32z' />
        <path d='M158.5 16h15.238v15.238H158.5V16Z' fill='#F35325' />
        <path d='M175.262 16H190.5v15.238h-15.238V16Z' fill='#81BC06' />
        <path d='M158.5 32.762h15.238V48H158.5V32.762Z' fill='#05A6F0' />
        <path d='M175.262 32.762H190.5V48h-15.238V32.762Z' fill='#FFBA08' />
        <path
            d='M165.797 139.497c.606.338 1.314.138 1.728-.426a23.615 23.615 0 0 0 1.961-2.977c.338-.606.18-1.39-.426-1.728-.681-.381-1.465-.222-1.804.383a22.13 22.13 0 0 1-1.876 2.827c-.414.563-.298 1.422.383 1.803-.042.076.034.118.034.118Zm5.075-9.086.151.085c.648.262 1.441-.09 1.703-.738.399-1.069.839-2.213 1.162-3.324.187-.691-.208-1.408-.856-1.67-.69-.187-1.407.207-1.669.855a21.723 21.723 0 0 1-1.153 3.131c-.187.69.132 1.365.662 1.661Zm2.709-10.009c.152.084.303.169.421.135.733.111 1.374-.325 1.485-1.058.171-1.195.3-2.315.396-3.554-.007-.699-.519-1.382-1.218-1.375-.775-.036-1.341.443-1.376 1.218a23.766 23.766 0 0 1-.387 3.36c-.102.539.225 1.02.679 1.274Zm.319-10.352c.227.127.496.178.69.187.742-.083 1.274-.68 1.191-1.421a58.571 58.571 0 0 0-.304-3.547c-.082-.742-.721-1.198-1.463-1.116-.741.083-1.198.722-1.115 1.464.141 1.171.248 2.224.312 3.353.058.43.31.868.689 1.08Zm-1.586-10.323c.303.17.573.22.927.12a1.34 1.34 0 0 0 .963-1.548 34.148 34.148 0 0 0-.969-3.422 1.257 1.257 0 0 0-1.59-.888c-.708.2-1.089.882-.888 1.59.301 1.062.677 2.167.936 3.304.058.43.318.675.621.844ZM161.136 94.015c.522.453 1.315.4 1.768-.122 1.907-2.172 4.143-5.015 5.354-8.307 2.39 1.626 5.084 3.154 8.276 3.37a1.25 1.25 0 0 0 1.328-1.169 1.249 1.249 0 0 0-1.169-1.328c-3.134-.195-5.823-2.078-8.409-3.897a1.23 1.23 0 0 0-1.158-.144c-.39.144-.684.478-.775.88-.836 3.497-3.28 6.627-5.317 8.962-.453.522-.4 1.315.123 1.768l-.021-.013ZM130.676 83.377c-.628-.295-1.321-.045-1.694.546-.636.947-1.23 2.01-1.746 3.108-.295.628-.082 1.4.546 1.694.707.332 1.477.119 1.772-.51a22.216 22.216 0 0 1 1.673-2.95c.373-.592.197-1.441-.51-1.773.037-.078-.041-.115-.041-.115Zm-4.423 9.42-.157-.073c-.664-.216-1.43.19-1.647.856-.322 1.094-.681 2.267-.924 3.398-.138.702.306 1.389.971 1.605.702.138 1.389-.306 1.605-.97.244-1.132.529-2.148.929-3.205.138-.702-.227-1.352-.777-1.61Zm-1.998 10.176c-.157-.073-.314-.147-.429-.105-.739-.06-1.347.421-1.407 1.16a53.646 53.646 0 0 0-.144 3.572c.056.697.615 1.343 1.312 1.287.776-.019 1.306-.537 1.287-1.312-.029-1.163.021-2.29.149-3.379.064-.545-.297-1.002-.768-1.223Zm.412 10.349a1.627 1.627 0 0 0-.702-.138c-.734.135-1.222.768-1.088 1.501a59.13 59.13 0 0 0 .553 3.517c.135.734.804 1.144 1.538 1.01.734-.135 1.144-.805 1.01-1.538a52.692 52.692 0 0 1-.548-3.323c-.088-.425-.37-.845-.763-1.029Zm2.309 10.185c-.314-.147-.587-.179-.933-.054a1.34 1.34 0 0 0-.852 1.611 34.216 34.216 0 0 0 1.208 3.346c.25.692.956 1.024 1.648.774a1.257 1.257 0 0 0 .774-1.649c-.375-1.038-.828-2.113-1.166-3.23-.088-.425-.365-.65-.679-.798ZM138.529 128.417a1.254 1.254 0 0 0-1.755.247c-1.749 2.301-3.78 5.294-4.756 8.664-2.498-1.454-5.294-2.788-8.493-2.78a1.249 1.249 0 0 0-1.242 1.26 1.25 1.25 0 0 0 1.26 1.243c3.14-.027 5.955 1.662 8.662 3.295.355.214.796.24 1.165.063.38-.172.649-.526.712-.934.587-3.547 2.804-6.841 4.671-9.314a1.254 1.254 0 0 0-.246-1.755l.022.011Z'
            fill='#0C0F33'
        />
        <rect y='159.911' width='217' height='178' rx='2.151' fill='#fff' />
        <rect x='16' y='175.911' width='23' height='11' rx='3' fill='#EBE8E8' />
        <rect x='43' y='175.911' width='23' height='11' rx='3' fill='#EBE8E8' />
        <rect x='70' y='175.911' width='23' height='11' rx='3' fill='#EBE8E8' />
        <rect x='97' y='175.911' width='23' height='11' rx='3' fill='#EBE8E8' />
        <rect x='124' y='175.911' width='23' height='11' rx='3' fill='#EBE8E8' />
        <rect x='151' y='175.911' width='23' height='11' rx='3' fill='#EBE8E8' />
        <rect x='178' y='175.911' width='23' height='11' rx='3' fill='#EBE8E8' />
        <rect x='16' y='190.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='43' y='190.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='70' y='190.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='97' y='190.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='124' y='190.911' width='23' height='23' rx='11.5' fill='#fff' />
        <rect x='124' y='190.911' width='23' height='23' rx='11.5' fill='#3B9ED7' />
        <rect x='151' y='190.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='178' y='190.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='16' y='217.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='43' y='217.911' width='23' height='23' rx='11.5' fill='#fff' />
        <rect x='43' y='217.911' width='23' height='23' rx='11.5' fill='#3B9ED7' />
        <rect x='70' y='217.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='97' y='217.911' width='23' height='23' rx='11.5' fill='#fff' />
        <rect x='97' y='217.911' width='23' height='23' rx='11.5' fill='#3B9ED7' />
        <rect x='124' y='217.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='151' y='217.911' width='23' height='23' rx='11.5' fill='#fff' />
        <rect x='151' y='217.911' width='23' height='23' rx='11.5' fill='#3B9ED7' />
        <rect x='178' y='217.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='16' y='244.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='43' y='244.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='70' y='244.911' width='23' height='23' rx='11.5' fill='#fff' />
        <rect x='70' y='244.911' width='23' height='23' rx='11.5' fill='#3B9ED7' />
        <rect x='97' y='244.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='124' y='244.911' width='23' height='23' rx='11.5' fill='#fff' />
        <rect x='124' y='244.911' width='23' height='23' rx='11.5' fill='#3B9ED7' />
        <rect x='151' y='244.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='178' y='244.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='16' y='271.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='43' y='271.911' width='23' height='23' rx='11.5' fill='#fff' />
        <rect x='43' y='271.911' width='23' height='23' rx='11.5' fill='#3B9ED7' />
        <rect x='70' y='271.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='97' y='271.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='124' y='271.911' width='23' height='23' rx='11.5' fill='#fff' />
        <rect x='124' y='271.911' width='23' height='23' rx='11.5' fill='#3B9ED7' />
        <rect x='151' y='271.911' width='23' height='23' rx='11.5' fill='#fff' />
        <rect x='151' y='271.911' width='23' height='23' rx='11.5' fill='#3B9ED7' />
        <rect x='178' y='271.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='16' y='298.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='43' y='298.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='70' y='298.911' width='23' height='23' rx='11.5' fill='#fff' />
        <rect x='70' y='298.911' width='23' height='23' rx='11.5' fill='#3B9ED7' />
        <rect x='97' y='298.911' width='23' height='23' rx='11.5' fill='#fff' />
        <rect x='97' y='298.911' width='23' height='23' rx='11.5' fill='#3B9ED7' />
        <rect x='124' y='298.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='151' y='298.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='178' y='298.911' width='23' height='23' rx='11.5' fill='#F7F7F7' />
        <rect x='225' y='159.911' width='76' height='21.742' rx='2.151' fill='#fff' />
        <rect x='225' y='185.954' width='76' height='21.742' rx='2.151' fill='#fff' />
        <rect x='225' y='211.997' width='76' height='21.742' rx='2.151' fill='#fff' />
        <rect x='225' y='238.04' width='76' height='21.742' rx='2.151' fill='#fff' />
        <rect x='225' y='264.083' width='76' height='21.742' rx='2.151' fill='#3B9ED7' />
        <rect x='225' y='290.126' width='76' height='21.742' rx='2.151' fill='#fff' />
        <rect x='225' y='316.169' width='76' height='21.742' rx='2.151' fill='#fff' />
        <path
            xmlns='http://www.w3.org/2000/svg'
            fill='#0B5CFF'
            d='M129.162 356.732c0 .962-.078 1.906-.225 2.826a7.203 7.203 0 0 1-5.949 5.949 17.784 17.784 0 0 1-5.652 0 7.2 7.2 0 0 1-5.949-5.949 17.784 17.784 0 0 1 0-5.652 7.2 7.2 0 0 1 5.949-5.949 17.775 17.775 0 0 1 5.652 0 7.203 7.203 0 0 1 5.949 5.949c.147.92.225 1.864.225 2.826Z'
        />
        <path
            xmlns='http://www.w3.org/2000/svg'
            fill='#fff'
            d='M122.09 358.983a.964.964 0 0 1-.964.964h-4.179a1.928 1.928 0 0 1-1.928-1.928v-3.536c0-.533.432-.964.964-.964h4.179c1.065 0 1.928.863 1.928 1.928v3.536Zm2.443-4.886-1.414 1.061a.964.964 0 0 0-.386.771v1.607c0 .304.143.59.386.772l1.414 1.06a.482.482 0 0 0 .772-.385v-4.5a.483.483 0 0 0-.772-.386Z'
        />
        <g xmlns='http://www.w3.org/2000/svg' clipPath='url(#m)'>
            <path
                fill='#00832D'
                d='m150.82 356.5 1.755 2.031 2.36 1.527.411-3.545-.411-3.467-2.405 1.342-1.71 2.112Z'
            />
            <path
                fill='#0066DA'
                d='M140.638 359.729v3.021c0 .691.552 1.25 1.234 1.25h2.983l.617-2.283-.617-1.988-2.047-.625-2.17.625Z'
            />
            <path
                fill='#E94235'
                d='m144.855 349-4.217 4.271 2.17.625 2.047-.625.607-1.961-.607-2.31Z'
            />
            <path fill='#2684FC' d='M144.855 353.271h-4.217v6.458h4.217v-6.458Z' />
            <path
                fill='#00AC47'
                d='m157.63 350.808-2.695 2.238v7.012l2.707 2.248c.405.321.998.028.998-.493v-10.521a.618.618 0 0 0-1.01-.484Zm-6.81 5.692v3.229h-5.965V364h8.845c.682 0 1.235-.559 1.235-1.25v-2.692l-4.115-3.558Z'
            />
            <path
                fill='#FFBA00'
                d='M153.7 349h-8.845v4.271h5.965v3.229l4.115-3.452v-2.798c0-.691-.553-1.25-1.235-1.25Z'
            />
        </g>
        <path
            fill='#5059C9'
            d='M183.753 354.375h4.907c.464 0 .84.362.84.807v4.3c0 1.639-1.381 2.968-3.085 2.968h-.015c-1.704 0-3.086-1.328-3.086-2.967v-4.686a.43.43 0 0 1 .439-.422ZM187.07 353.525c1.098 0 1.988-.857 1.988-1.913s-.89-1.912-1.988-1.912c-1.098 0-1.989.856-1.989 1.912s.891 1.913 1.989 1.913Z'
        />
        <path
            fill='#7B83EB'
            d='M180.884 353.525c1.586 0 2.872-1.237 2.872-2.762 0-1.526-1.286-2.763-2.872-2.763-1.587 0-2.872 1.237-2.872 2.763 0 1.525 1.285 2.762 2.872 2.762ZM184.713 354.375h-8.101c-.458.011-.82.377-.81.817v4.904c-.064 2.645 2.111 4.839 4.861 4.904 2.749-.065 4.924-2.259 4.86-4.904v-4.904c.011-.44-.352-.806-.81-.817Z'
        />
        <path
            fill='#000'
            d='M181.105 354.375v6.872a.783.783 0 0 1-.504.718c-.096.04-.2.06-.305.06h-4.105a5 5 0 0 1-.389-1.929v-4.905c-.01-.44.352-.805.809-.816h4.494Z'
            opacity='.1'
        />
        <path
            fill='#000'
            d='M180.663 354.375v7.297a.72.72 0 0 1-.062.293.814.814 0 0 1-.747.485h-3.455a5.557 5.557 0 0 1-.208-.425 3.948 3.948 0 0 1-.154-.425 5 5 0 0 1-.235-1.504v-4.905c-.01-.44.352-.805.809-.816h4.052Z'
            opacity='.2'
        />
        <path
            fill='#000'
            d='M180.663 354.375v6.447c-.004.428-.364.775-.809.778h-3.817a5 5 0 0 1-.235-1.504v-4.905c-.01-.44.352-.805.809-.816h4.052Z'
            opacity='.2'
        />
        <path
            fill='#000'
            d='M180.221 354.375v6.447c-.003.428-.363.775-.809.778h-3.375a5 5 0 0 1-.235-1.504v-4.905c-.01-.44.352-.805.809-.816h3.61Z'
            opacity='.2'
        />
        <path
            fill='#000'
            d='M181.105 352.178v1.338a3.265 3.265 0 0 1-.221.009c-.075 0-.146-.004-.221-.009a2.447 2.447 0 0 1-.442-.068 2.84 2.84 0 0 1-1.988-1.623 2.281 2.281 0 0 1-.142-.425h2.205c.446.002.807.349.809.778Z'
            opacity='.1'
        />
        <path
            fill='#000'
            d='M180.663 352.603v.914a2.638 2.638 0 0 1-.442-.068 2.844 2.844 0 0 1-1.988-1.624h1.621c.446.002.807.349.809.778Z'
            opacity='.2'
        />
        <path
            fill='#000'
            d='M180.663 352.603v.914a2.638 2.638 0 0 1-.442-.068 2.844 2.844 0 0 1-1.988-1.624h1.621c.446.002.807.349.809.778Z'
            opacity='.2'
        />
        <path
            fill='#000'
            d='M180.221 352.603v.846a2.844 2.844 0 0 1-1.988-1.624h1.179c.446.002.807.349.809.778Z'
            opacity='.2'
        />
        <path
            fill='#4E55BC'
            d='M171.31 351.825h8.101c.447 0 .81.349.81.779v7.792c0 .43-.363.779-.81.779h-8.101c-.447 0-.81-.349-.81-.779v-7.792c0-.43.363-.779.81-.779Z'
        />
        <path
            fill='#fff'
            d='M177.492 354.791h-1.619v4.241h-1.032v-4.241h-1.612v-.823h4.263v.823Z'
        />
        <defs>
            <pattern id='a' patternContentUnits='objectBoundingBox' width='1' height='1'>
                <use transform='scale(.0005 .00049)' />
            </pattern>
            <pattern id='d' patternContentUnits='objectBoundingBox' width='1' height='1'>
                <use transform='matrix(.00086 0 0 .00102 -.017 0)' />
            </pattern>
            <pattern id='e' patternContentUnits='objectBoundingBox' width='1' height='1'>
                <use transform='scale(.00045 .00049)' />
            </pattern>
            <radialGradient
                id='b'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='matrix(12.1344 0 0 10.1417 123.5 356.365)'
            >
                <stop offset='.82' />
                <stop offset='.98' />
            </radialGradient>
            <radialGradient
                id='c'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='matrix(12.13 0 0 10.138 123.5 358.453)'
            >
                <stop offset='.8' />
                <stop offset='1' />
            </radialGradient>
        </defs>
    </svg>
);
